"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendCrudErrorCodes = exports.CrudErrorCodes = void 0;
/**
 * Стандартные CRUD error codes — readonly tuple для z.enum() в reply-схемах.
 *
 * Покрывают типовые ошибки CRUD-операций. Domain-специфичные коды (например
 * `already_closed`, `dns_lookup_failed`) добавляются через `extendCrudErrorCodes`
 * — readonly tuple конкатенируется, тип расширяется через union.
 *
 * @example
 *   import { CrudErrorCodes } from '@omniflow/contracts-base';
 *   FooCreateReplyV1 = crudCreateReply(FooSnapshot, CrudErrorCodes);
 *
 *   // С доменным расширением:
 *   const SessionCloseCodes = extendCrudErrorCodes('already_closed', 'cannot_close_active_call');
 *   SessionCloseReplyV1 = crudReply(z.object({}), SessionCloseCodes);
 */
exports.CrudErrorCodes = [
    /** Entity с таким id не существует (для update/delete/get). */
    'not_found',
    /** Поля payload не прошли zod-валидацию или domain-проверку. */
    'validation_error',
    /** Нарушение уникальности (username занят, externalKey коллизия, etc). */
    'conflict',
    /** Авторизация: cross-tenant попытка, недостаточная роль, и т.п. */
    'forbidden',
    /** RLS mismatch: tenant_id сущности не совпадает с tenant контекста. */
    'tenant_mismatch',
];
/**
 * Расширить стандартные коды доменными. Возвращает readonly tuple, который
 * можно передать в `crudReply`/`crudCreateReply` помойке.
 *
 * @example
 *   const SessionCodes = extendCrudErrorCodes('already_closed', 'cannot_close_active_call');
 *   // type: readonly ['not_found','validation_error','conflict','forbidden','already_closed','cannot_close_active_call']
 */
const extendCrudErrorCodes = (...extra) => {
    return [...exports.CrudErrorCodes, ...extra];
};
exports.extendCrudErrorCodes = extendCrudErrorCodes;
//# sourceMappingURL=error-codes.js.map